;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { PageErrorCode } from './PageErrorCode'
import { PageErrorLogo } from './PageErrorLogo'
import { PageErrorTitle } from './PageErrorTitle'

export const PageError = {
  Logo: PageErrorLogo,
  Title: PageErrorTitle,
  Code: PageErrorCode,
}
